import { Inject, Injectable } from '@angular/core'
import { defer, EMPTY, filter, from, map, Observable, of, tap, throwError } from 'rxjs'
import { CollectedData } from '@features/risks-integrations/contracts'
import { SupportedScripts } from '@features/script-loader'
import { WINDOW } from '@features/storage/window'
import { catchError } from 'rxjs/operators'
import { ScriptLoader } from '@sun-finance/utils'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const errorHandler = (e: any) => {
    // Throw error in different subscriber scope in order to see it but finish observable successfully
    throwError(() => e).subscribe()

    return of(null)
}

@Injectable()
export abstract class DeviceDataCollectorService {

    abstract collectDeviceData(): Observable<CollectedData>
}

@Injectable()
export class ExternalProvidersDeviceDataCollectorService extends DeviceDataCollectorService {

    constructor(private scriptLoader: ScriptLoader, @Inject(WINDOW) private readonly window: Window) {
        super()
    }

    collectDeviceData(): Observable<CollectedData> {
        return this.seonSession().pipe(
            map(seonSession$ => ({ seonSession$ })),
        )
    }

    private seonSession(): Observable<CollectedData['seonSession$']> {
        const script$ = this.window.seon ? of(this.window.seon) : this.scriptLoader.load(SupportedScripts.SEON).pipe(
            map(() => this.window.seon),
            filter(Boolean),
            tap(seon => seon.init()),
            catchError(errorHandler)
        )

        return script$.pipe(
            map(seon => seon ? defer(() => from(seon.getSession())) : of(null)),
        )
    }
}

@Injectable()
export class NoopDeviceDataCollectorService extends DeviceDataCollectorService {

    collectDeviceData(): Observable<CollectedData> {
        return EMPTY
    }
}
